import { CommonModule } from '@angular/common';
import { APP_INITIALIZER, ModuleWithProviders, NgModule } from '@angular/core';

import { initRecaptchaScriptLoaderService } from './recaptcha-script-loader-init';
import { RecaptchaScriptLoaderService } from './recaptcha-script-loader.service';

@NgModule({
  imports: [CommonModule],
})
export class RecaptchaSharedUtilCoreModule {
  static forRoot(): ModuleWithProviders<RecaptchaSharedUtilCoreModule> {
    return {
      ngModule: RecaptchaSharedUtilCoreModule,
      providers: [
        {
          provide: APP_INITIALIZER,
          useFactory: initRecaptchaScriptLoaderService,
          deps: [RecaptchaScriptLoaderService],
          multi: true,
        },
      ],
    };
  }
}
